import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

//  IMPORT CORRECTO EN v8
import SwiperCore, { EffectCards } from "swiper";

import "swiper/swiper-bundle.min.css";
import "./PhotoCardsSwiper.css";

//  REGISTRA EL MÓDULO (v8)
SwiperCore.use([EffectCards]);

const PhotoCardsSwiper = ({ images = [] }) => {
  return (
    <Swiper
      effect="cards"
      grabCursor={true}
      className="photo-cards-swiper"
    >
      {images.map((img, index) => (
        <SwiperSlide key={index}>
          <img
            src={img}
            alt={`Galería ${index + 1}`}
            className="cards-image"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default PhotoCardsSwiper;
